import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { CancellationReasonRetenoValue } from 'pages/account/components/SubscriptionsTab/modals/CancellationReasonModal/types';

import {
    IDiscountSubscription,
    IFetchDiscountSubscription,
    IUpdateSubscriptionData,
    SubscriptionPauseType,
} from 'types/subscription';

import * as actionTypes from './actionTypes';

export const fetchSubscriptions = () => {
    return {
        type: actionTypes.FETCH_USER_SUBSCRIPTIONS_REQUEST,
    } as const;
};

export const fetchSubscriptionsSuccess = (payload: Array<ISubscriptionWellfunnel>) => {
    return {
        type: actionTypes.FETCH_USER_SUBSCRIPTIONS_SUCCESS,
        payload,
    } as const;
};

export const fetchSubscriptionsError = () => {
    return {
        type: actionTypes.FETCH_USER_SUBSCRIPTIONS_ERROR,
    } as const;
};

export const cancelSubscription = (payload: { cancellationCandidates: ISubscriptionWellfunnel[] }) => {
    return {
        type: actionTypes.CANCEL_SUBSCRIPTION,
        payload,
    } as const;
};

export const resetSubscriptions = () => {
    return {
        type: actionTypes.RESET_SUBSCRIPTIONS,
    } as const;
};

export const sendFeedback = (payload: { reason: CancellationReasonRetenoValue }) => {
    return {
        type: actionTypes.SEND_SUBSCRIPTION_FEEDBACK,
        payload,
    } as const;
};

export const setCancelReason = (payload: CancellationReasonRetenoValue) => {
    return {
        type: actionTypes.SET_CANCEL_REASON,
        payload,
    } as const;
};

export const updateSubscription = (payload: IUpdateSubscriptionData) => {
    return {
        type: actionTypes.UPDATE_SUBSCRIPTION,
        payload,
    } as const;
};

export const setCancellationCandidates = (payload: ISubscriptionWellfunnel[] | null) => {
    return {
        type: actionTypes.SET_CANCELLATION_CANDIDATE,
        payload,
    } as const;
};

export const fetchDiscountSubscription = (payload: IFetchDiscountSubscription) => {
    return {
        type: actionTypes.FETCH_DISCOUNT_SUBSCRIPTION_REQUEST,
        payload,
    } as const;
};

export const fetchDiscountSubscriptionSuccess = (payload: IDiscountSubscription | null) => {
    return {
        type: actionTypes.FETCH_DISCOUNT_SUBSCRIPTION_SUCCESS,
        payload,
    } as const;
};

export const fetchDiscountSubscriptionError = () => {
    return {
        type: actionTypes.FETCH_DISCOUNT_SUBSCRIPTION_ERROR,
    } as const;
};

export const restoreSubscription = (payload: ISubscriptionWellfunnel) => {
    return {
        type: actionTypes.RESTORE_SUBSCRIPTION,
        payload,
    } as const;
};

export const pauseSubscription = (payload: {
    externalIds: string[];
    pause_type: SubscriptionPauseType;
    provider: string;
}) => {
    return {
        type: actionTypes.PAUSE_SUBSCRIPTION,
        payload,
    } as const;
};

export const resumeSubscription = (payload: { external_id: string; date: string; provider: string }) => {
    return {
        type: actionTypes.RESUME_SUBSCRIPTION,
        payload,
    } as const;
};

export const setReminder = (payload: { externalIds: string[]; provider: string }) => {
    return {
        type: actionTypes.SET_REMINDER,
        payload,
    } as const;
};

export const requestCancelSubscriptionWithOffer = (payload: ISubscriptionWellfunnel[]) => {
    return {
        type: actionTypes.CANCEL_SUBSCRIPTION_WITH_OFFER,
        payload,
    } as const;
};

export const requestResetSubscription = (payload: boolean) => {
    return {
        type: actionTypes.RESET_SUBSCRIPTION,
        payload,
    } as const;
};
